// extracted by mini-css-extract-plugin
export var closed = "styles-module--closed--24c32";
export var intl_menu = "styles-module--intl_menu--0cdd1";
export var open = "styles-module--open--bb9ca";